import appManager from 'AppManager/index';
import {
    getAssetTitle,
    getTitleByModelType,
    isArchive,
    isLiveTv,
    ITEM_TYPES,
    itemHasStarted
} from 'Utils';
import { t } from 'Locale/index';
import { NUMBERING_EPISODE, TITLE } from '@24i/st-api-connector/utils';

export const sortEpisodes = (firstEp, secondEp) => {
    try {
        return firstEp.getEpisodeNumber() - secondEp.getEpisodeNumber();
    } catch (err) {
        return firstEp.data?.startTime - secondEp.data?.startTime;
    }
};

export const generateEpisodeHeaderTitle = (parentItem, item) =>
    `${getAssetTitle(parentItem, TITLE)}, ${getAssetTitle(item, NUMBERING_EPISODE)}`;

export const getPickerItemByType = (item) => {
    const title = getAssetTitle(item, NUMBERING_EPISODE);
    return { title, value: title };
};

export const getPickerItems = (parentItem, currentItem, lang) => {
    const dataKey = currentItem.modelType === ITEM_TYPES.SEASON ? 'seasons' : 'episodes';
    return (
        parentItem[dataKey].map((item, index) => ({
            ...getPickerItemByType(item, lang),
            index
        })) ?? []
    );
};

export const getHeaderTitleByItem = (item) => {
    let headerTitle;

    if (isArchive(item)) {
        headerTitle = t('COMMON.ARCHIVE');
    } else if (item?.modelType === ITEM_TYPES.CONTINUE_WATCHING) {
        // If original type in continue watching is TV, treat it as archive
        headerTitle =
            item?.originalModelType === ITEM_TYPES.TV
                ? t('COMMON.ARCHIVE')
                : getTitleByModelType(item?.originalModelType);
    } else if (!itemHasStarted(item) && isLiveTv(item)) {
        headerTitle = t('COMMON.LIVE_TV_FUTURE');
    } else {
        headerTitle = getTitleByModelType(item?.modelType);
    }

    return headerTitle.toUpperCase();
};

// TODO: Refactor back seriesIds to id which needs to be unique series id
export const getRecSeriesItem = async (seriesIds = [], planned = false) => {
    try {
        const { items } = await appManager
            .getApi()
            .fetchAllRecordings({ platform: 'go,iptv', planned });
        return items.find(({ data }) => seriesIds.includes(data.id));
    } catch (error) {
        throw error;
    }
};
